import React from 'react';
import { Listbox } from '@headlessui/react';
import { buttonRootStyle } from '@teetsh/app/src/components/Buttons/Button';
import tw from 'twin.macro';
import { ChevronDownIcon as ChevronDown } from '@heroicons/react/24/outline';
import { ChevronUpIcon as ChevronUp } from '@heroicons/react/24/outline';
import { Intent } from '@teetsh/app/src/components/Buttons/BaseButtonProps';

interface Props {
  intent?: Intent;
  placement: 'top' | 'bottom';
}

export function ListButton(props: Props) {
  const { intent, placement } = props;
  return (
    <Listbox.Button
      className="tsh-button"
      css={[
        buttonRootStyle({
          large: true,
          intent,
          hasChildren: true,
        }),
        intent === 'primary' && tw`border-l border-brand-moderate`,
        tw`rounded-l-none pl-3`,
      ]}
    >
      {placement === 'bottom' ? (
        <ChevronDown tw="h-5 w-5" aria-hidden="true" />
      ) : (
        <ChevronUp tw="h-5 w-5" aria-hidden="true" />
      )}
    </Listbox.Button>
  );
}
